<template>
    <div>
        <div class="main-h">
            <div class="mt-4">
                <router-link :to="'/role-links/student/start-exam'" style="text-decoration: none;" class="root">
                    <v-icon left color="white" class="home-icon">mdi-keyboard-backspace</v-icon>
                    <span class="home-text"><strong>Home</strong></span>
                </router-link>
            </div>
        </div>
        <br />
        <br />
        <br />
        <br />
        <br />
        <center><v-img class="img" src="@/assets/end_exam.png"></v-img></center>
        <p>Exam Submitted successfully...</p>
        <p>Thank You<span class="rotate">:)</span></p>
    </div>
</template>

<script>
    import axios from "axios";
    export default {
        data: () => ({
            snackbar_msg: "",
            snackbar: false,
            color: "",
            org: null,
            les_id: null,

            //
        }),
        watch: {},
        methods: {
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
        },
        mounted() {
            //   this.les_id = localStorage.getItem("summury_id");
            //   alert("les_id : "+this.les_id)
            //   const formData = {
            //         les_id: this.les_id,
            //       };
            // axios
            //     .post("/Student/getSummury" ,formData)
            //     .then(res => {
            //       if (res.data.msg == "200") {
            //         //4CAF50
            //       }
            //     })
            //     .catch(error => {
            //       this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
            //     })
            //     .finally(()=>{
            //     });
        },
    };
</script>
<style scoped>
    p {
        font-size: 3vw;
        font-weight: 400;
        text-align: center;
        color: green;
        text-shadow: 0 0 5px #006108, 0 0 1px #215834;
    }
    .rotate {
        display: block;
        transform: rotate(90deg);
    }
    .img {
        width: 25%;
    }
    div {
        overflow: hidden;
    }
    .main-h {
        display: flex;
        justify-content: space-between;
        padding: 1rem 1rem 1.5rem 1rem;
        position: fixed;
        top: 0;
        width: 100%;
        z-index: 1;
        background: linear-gradient(130deg, hsla(190, 99%, 30%, 1) 0%, hsla(226, 50%, 65%, 1) 180%);
    }
    .home-icon {
        margin-top: -5px;
    }

    .home-text {
        color: white;
        margin-top: 3px !important;
        font-size: 16px;
        font-weight: bold;
        padding-bottom: 2rem;
    }
</style>
